export default "__VITE_ASSET__c2e10f63__"